import { createReducer } from "@reduxjs/toolkit";
import {
  getContentRequestMockData,
  getContentRequestMockDataFailure,
  getContentRequestMockDataSuccess,
  setContentRequestForm,
  toggleContentRequestModal,
} from "@redux/contentRequest/actions";

const initialState = {
  data: {},
  formValues: {},
  isLoading: false,
  error: null,
  isModalVisible: false,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getContentRequestMockData.type, (state) => {
      state.isLoading = true;
    })
    .addCase(getContentRequestMockDataSuccess.type, (state, { payload }) => {
      state.isLoading = false;
      state.data = { ...payload };
    })
    .addCase(getContentRequestMockDataFailure.type, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload.error;
    })
    .addCase(setContentRequestForm.type, (state, { payload }) => {
      state.formValues = { ...payload };
    })
    .addCase(toggleContentRequestModal.type, (state, { payload }) => {
      state.isModalVisible = payload;
    });
});
